import * as BABYLON from '@babylonjs/core';
import eventEnable from '../core/eventEnable';
export default class BabylonModel{
	constructor(props){
		const {root, babylonMeshes, particleSystems, skeletons, code, location, objectIdNodeIdsMappings, quadrants}=props;
		eventEnable(this);
		this._root = root;
		this._objectIdNodeIdsMappings= objectIdNodeIdsMappings;
		this._quadrants = quadrants;
		this._babylonMeshes = babylonMeshes;
		this._particleSystems = particleSystems;
		this._skeletons = skeletons;
		this._code = code;
		this._location = location;
		this.setLocation = this.setLocation.bind(this);
		this.setVisibleObjects = this.setVisibleObjects.bind(this);
		this._setNodeEnabled = this._setNodeEnabled.bind(this);
		this.dispose = this.dispose.bind(this);
		this._setPositionRotationAndScaling = this._setPositionRotationAndScaling.bind(this);
		this.setAllObjectsVisible = this.setAllObjectsVisible.bind(this);
		this.clone = this.clone.bind(this);
		this._mapNodeIdToBabylonMesh = new Map();
		this._currentNodeIdsVisible = [];
		babylonMeshes.forEach(babylonMesh=>{
			if(babylonMesh.id.indexOf('node')!==0)return;
			const number = parseInt(babylonMesh.id.substr(4));
			this._mapNodeIdToBabylonMesh.set(number, babylonMesh);
			this._currentNodeIdsVisible.push(number);
		});
	}
	get code(){
		return this._code;
	}
	get quadrants(){
		return this._quadrants;
	}
	setLocation(location){
		this._setPositionRotationAndScaling(location.position, location.rotation, location.scaling);
	}
	setAllObjectsVisible(){
		for(var nodeId of this._objectIdNodeIdsMappings.allNodeIds){
			this._setNodeEnabled(nodeId, true);
		}
		this._currentNodeIdsVisible = this._objectIdNodeIdsMappings.allNodeIds;
	}
	setVisibleObjects(objectIds){
		const nodeIdsVisible = this._objectIdNodeIdsMappings.getNodeIdsForObjectIds(objectIds);
		nodeIdsVisible.forEach((nodeIdVisible)=>{
			const indexInCurrentNodeIdsVisible = this._currentNodeIdsVisible.indexOf(nodeIdVisible);
			if(indexInCurrentNodeIdsVisible>=0)
				this._currentNodeIdsVisible.splice(indexInCurrentNodeIdsVisible, 1);
			else
				this._setNodeEnabled(nodeIdVisible, true);
		});
		this._currentNodeIdsVisible.forEach(nodeIdToDisable=>this._setNodeEnabled(nodeIdToDisable, false));
		this._currentNodeIdsVisible = nodeIdsVisible;
	}
	_setNodeEnabled(nodeId, enabled){	
		const mesh = this._mapNodeIdToBabylonMesh.get(nodeId);
		if(!mesh)return;
		mesh.setEnabled(enabled);	
	}
    _setPositionRotationAndScaling(position, rotation, scaling) {
        this._root.position= new BABYLON.Vector3(position.x, position.y, position.z);
        this._root.rotation = new BABYLON.Vector3(rotation.x, rotation.y, rotation.z); 
        this._root.scaling = new BABYLON.Vector3(scaling.x, scaling.y, scaling.z);
    }
	clone(){
		const clonedRoot = this._root.clone();
		return new BabylonModel({
			root:this._root,
			babylonMeshes:this._babylonMeshes,
			particleSystems:this._particleSystems,
			skeletons:this._skeletons,
			code:this._code,
			location:this._location
		});
	}
	dispose(){
		this.dispatchEvent({type:'disposed', babylonModel:this});
	}
}